import React from 'react';
import Immutable from 'immutable';
import CommentListItem from './CommentListItem';
import PostCountBar from '../../components/PostCountBar';
import { COMMENT } from '../../constants/ModalTypes';

const CommentList = ({ post, device, showModal, fetchComments, toggleDirectionAndEmptyItems }) => {
  const { id, author, comments } = post;
  const items = comments.get('items', Immutable.List());
  const hasNext = comments.get('hasNext', false);
  const direction = comments.get('direction', 'backward');
  const isFetching = comments.get('isFetching', false);
  const getCommentsFromFirst = () => {
    toggleDirectionAndEmptyItems(id);
    fetchComments(author.id, id, { direction: comments.get('direction') !== 'forward' ? 'forward' : 'backward' });
  };
  const deviceOsName = device.getIn(['os', 'name']);
  const isPC = deviceOsName !== 'Android' && deviceOsName !== 'iOS';

  return (
    <div className="post_cmt">
      <strong className="screen_out">댓글영역</strong>
      <PostCountBar profile={post.author} post={post} device={device} showModal={showModal} />
      {
        hasNext && direction !== 'forward' && (<div className="cmt_btn">
          <button type="button" className="btn_cmt"
            onClick={() => fetchComments(author.id, id,
                { since: items.first().get('id'),
                  direction
                })}>
            <span className="inner_txt"><span className="ico_plus ico_prev" />이전 댓글</span>
          </button>
          <button type="button" className="btn_cmt" onClick={() => getCommentsFromFirst(author.id, id)}>
            <span className="inner_txt"><span className="ico_plus ico_fst" />처음 댓글</span>
          </button>
        </div>)
      }

      <div className="cmt_bundle">
        {
          !post.commentable &&
            <p className="desc_notify">댓글을 작성 할 수 없는 포스트입니다.</p>
        }
        {
          post.commentable && items.isEmpty() && !isFetching ? (<p className="desc_empty">등록된 댓글이 없습니다.<br />가장 먼저 댓글을 남겨보세요.</p>)
            : items
              .filter((comment) => !!comment)
              .map((comment, idx) => <CommentListItem comment={comment} key={idx}/>)
        }
        {
          post.commentable && hasNext && direction === 'forward' && (
            <button type="button" className="btn_more"
              onClick={() => fetchComments(author.id, id,
                { since: items.last().get('id'),
                  direction
                }
              )}
            >
              <span className="ico_plus" />댓글 더보기
            </button>
          )
        }
      </div>
      {
        post.commentable &&
          <div className="box_appinfo">
            <button type="button" className="btn_appinfo"
                    onClick={() => !isPC && showModal(COMMENT, { post, device })}
                    disabled={isPC} style={{ cursor: 'default' }}
            >
            <span className="inner_txt">
              <span className="ico_plus ico_kakao" />
              <span className="txt_info" style={{ display: isPC ? 'inline' : 'none' }}>
                댓글 입력은 카카오톡 모바일 앱에서 가능합니다.
              </span>
              <span className="txt_info2" style={{ display: isPC ? 'none' : 'inline' }}>
                카카오톡앱에서 댓글 달기
              </span>
            </span>
            </button>
          </div>
      }
    </div>
  );
};

export default CommentList;




// WEBPACK FOOTER //
// ./src/components/CommentList/index.js